import {  UseFormRegister, UseFormSetValue, UseFormWatch } from "react-hook-form";
import MgpFormSelect from "../../elements/MgpFormSelect/MgpFormSelect";
import MgpFormCheckbox from "../../elements/MgpFormCheckbox/MgpFormCheckbox";
import MgpFormInput from "../../elements/MgpFormInput/MgpFormInput";
import InfoAddressInputTemplate from "./InfoAddressInputTemplate";
import {  IOption } from "../../context/model";
import MgpFormRadio from "../../elements/MgpFormRadio/MgpFormRadio";
import { APP_RETIREMENT_URLS, APP_URLS } from "../../const/AppConst";


interface InfoOldContractComponentProps {
    register: UseFormRegister<any>;
    errors: any;
    watch: UseFormWatch<any>,
    setValue : UseFormSetValue<any>,
    concurrentOptions: IOption[],
    isRetired?: boolean
}
export default function InfoOldContractComponent({ 
    register, 
    errors,
    watch , 
    setValue,
    concurrentOptions,
    isRetired
}: Readonly<InfoOldContractComponentProps>) {
  
        const onChangeConcurrentMode = ()=> {
            setValue('contractNumbers', '');
            setValue('otherName', '');
            setValue('buildingName', '');
            setValue("address",'');
            setValue("postalCode", '');
            setValue("city", '');
            setValue('name', '');
            setValue("additionalAddress", '')
        }

        return (
            <div className='page-content mw-100'>
                <div>
                    {isRetired &&
                    <>
                        <p className="text mt-sm">J'ai un contrat santé à la MGP <span className='fushia'>(*)</span></p>
                        <div className="groupRadio mt-sm">
                            <div>
                                <MgpFormRadio id="hasMgpInsurance" value='true' label='Oui' register={register} errors={errors} />
                            </div>
                            <div>
                                <MgpFormRadio id="hasMgpInsurance" value='false' label='Non' register={register} errors={errors} />
                            </div>  
                        </div>
                    </>
                   }

                    {watch('hasMgpInsurance') === 'true' && 
                        <div>
                            <p className="text mt-sm">La MGP prend en charge la résiliation de votre contrat actuel à J-1 de la date d'effet de votre affiliation au contrat collectif de votre employeur.</p>
                        </div>
                    }

                    {watch('hasMgpInsurance') === 'false' &&    
                        <>
                            <div className="" >
                                <p className="text fw-medium form-group ">
                                    Sélectionnez votre ancienne complémentaire santé <span className="fushia">(*)</span>
                                </p>
                                <div className=" form-group">
                                    <MgpFormSelect 
                                        id={'name'}
                                        labelFontWeight='regular'
                                        data={concurrentOptions}
                                        register={register}
                                        errors={!watch('isOtherName') && errors}
                                        value={watch('name')}
                                        required={!watch('isOtherName')}
                                        disabled={watch('isOtherName')}
                                    />                   
                                </div>
                            </div>
                            <div style={{display: "block"}}>
                                <div style={{display: "block"}}>
                                    <div 
                                        className="form-group form-check mw-100" 
                                        onChange={onChangeConcurrentMode}
                                    >
                                        <MgpFormCheckbox 
                                            id="isOtherName" 
                                            label='Mon ancienne complémentaire santé ne figure pas dans cette liste' 
                                            register={register} 
                                            errors={errors} 
                                            labelFontWeight='normal'
                                            style={{display: 'block'}}
                                            />          
                                    </div>       
                                </div>

                                {((!isRetired  && watch("isOtherName") === false) || isRetired) && 
                                    <div className="form-row  va-center mb-xs">
                                        <div className="form-group">
                                            <MgpFormInput 
                                                id="contractNumbers"
                                                labelFontWeight='regular'
                                                register={register}
                                                errors={errors}
                                                label="Numéro(s) de contrat, séparé par des virgules"
                                                required={true}
                                                key={ watch('isOtherName') === true ? 'other-name-contract' : 'select-available-contract'}
                                                maxLength={30}
                                            />
                                        </div>       
                                    </div>
                                }
                            
                                {
                                    watch("isOtherName") === true && 
                                    <div className="">
                                        {isRetired ?
                                            <div>
                                                <div className='form-row'>
                                                    <div className="form-group col-flex-4 px-lg">
                                                        <MgpFormInput 
                                                            id="otherName"
                                                            labelFontWeight='regular'
                                                            register={register}
                                                            errors={errors}
                                                            label="Nom de votre ancienne complémentaire santé"
                                                            required={true}
                                                            autoCapitalize="characters"
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-flex-4 px-lg'>
                                                    <InfoAddressInputTemplate 
                                                        register={register} 
                                                        watch={watch} 
                                                        errors={errors} 
                                                        setValue={setValue}
                                                        globalSave={false}
                                                        countryShow={false}
                                                        currentStep={isRetired ? APP_RETIREMENT_URLS.infoOldContractPage : APP_URLS.infoOldContractPage}
                                                        hasLieudit={false}
                                                    />
                                                </div> 
                                            </div>
                                            :
                                            <div>
                                                <p className="text mt-md">Si votre organisme complémentaire ne fait pas partie de la liste indiquée, la MGP ne prend pas en charge la résiliation auprès de celle-ci. Vous pouvez néanmoins utiliser notre outil de génération de lettre de résiliation en cliquant sur le lien suivant pour faciliter votre démarche : <a className="link button-bloc" href={process.env.REACT_APP_MINI_SITE_RIA} target="_blank">cliquez ici</a></p>
                                            </div>
                                        }        
                                    </div> 
                                }    
                            </div>  
                        </>     
                    }                        
                    </div>
                <div>
            </div>      
        </div>
     )
}
